<validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
<form [formGroup]="form">
    <h2>Additional Requirements Details</h2>
    <fieldset>
        <div class="row">
            <div class="col-sm-12 mvd_form-group">
                <label class="mvd_label--inline">
                    <input type="checkbox" formControlName="correctiveLens" value="test" />
                    A corrective lens/hearing aid restriction must be added to your Commercial Driver License (CDL) or permit. A duplicate CDL or permit showing the required restriction must be obtained. A
                    duplicate license fee will be charged.
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 mvd_form-group">
                <label class="mvd_label--inline">
                    <input type="checkbox" formControlName="stateWaiver" />
                    The Medical Examiner's Certificate is issued as having a State Waiver/Variance. If you do not require a Waiver/Variance to be on file, please resubmit a corrected copy of your medical certificate.
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 mvd_form-group">
                <label class="mvd_label--inline">
                    <input type="checkbox" formControlName="safetyRegulations" />
                    The Medical Examiner's Certificate must indicate that the examination performed meets the Federal Motor Carrier Safety Regulations according to 49 CFR 391.41-391.49. Please resubmit a
                    corrected copy of your medical certificate.
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 mvd_form-group">
                <label class="mvd_label--inline">
                    <input type="checkbox" formControlName="providedMec" />
                    We have not received the Medical Examiner's Certificate which you provided at a driver license office. Please provide a copy of your current Medical Examiner's Certificate.
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 mvd_form-group">
                <label class="mvd_label--inline">
                    <input type="checkbox" formControlName="incompleteMec" />
                    Incomplete Medical Examiner's Certificate - All Physician/Driver Information must be completed on the certification page or the medical examiner certifictae/card, including a legible printed
                    name, medical license/certificate number, issuing state, phone number, driver license number, signature, National Registry Number. Please resubmit a corrected copy of your Medical
                    Examiner's Certificate.
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 mvd_form-group">
                <label class="mvd_label--inline">
                    <input type="checkbox" formControlName="expiredMec" />
                    The Medical Examiner's Certificate issue/expiration date is incomplete and/or cannot exceed a period of 2 years. Please submit a corrected copy of your Medical Examiner's Certificate.
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 mvd_form-group">
                <label class="mvd_label--inline">
                    <input type="checkbox" formControlName="additionalInfo" />
                    Additional Info
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 mvd_form-group">
                <label>Additional Information</label>
                <textarea class="mvd_form-control" formControlName="additionalInfoText" rows="10" cols="75" maxlength="190"></textarea>
            </div>
        </div>
    </fieldset>
</form>
<div class="well__footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [isDisabled]="!form.valid" [isLoading]="false" btnText="Save" (clicked)="save()"></mvm-spinner-btn>
    </div>
</div>